import { error as logError } from '../utils/logger'
import { apiUrl } from "../config/config"
import { sendRequest } from "../utils/FetchServices"
import { SEND_REQUEST_STATUS } from '../components/customUtils/AppConstants'


export interface SaveTrackingsResponse {
    status: number
    response: {
        status: number
        trackinsCreates: number[]
    }
    duration: number
    retries: number
}

export const request_save_trackings = async ({ authToken, body }): Promise<SaveTrackingsResponse> => {
    const URL_SAVE_TRACKINGS = apiUrl + '/save_trackings'
    try {
        // ✅ Validate auth token before making request
        if (!authToken || authToken.trim() === '') {
            throw new Error('Auth token is missing or empty')
        }

        const headers = {
            Authorization: authToken,
        }
        const response = await sendRequest(URL_SAVE_TRACKINGS, 'POST', headers, body, 0, 30, null, [], false)
        
        // ✅ Check for 401 specifically
        if (response.status === SEND_REQUEST_STATUS.ERROR && response.error?.includes('401')) {
            logError('TrackingService', 'Authentication failed (401). Token may be expired or invalid.')
        }
        
        return response
    } catch (error) {
        // ✅ Improved error logging
        const errorMessage = error?.message || String(error)
        if (errorMessage.includes('401') || errorMessage.includes('Unauthorized')) {
            logError('TrackingService', 'Authentication error in request_save_trackings. Please check token validity:', errorMessage)
        } else if (errorMessage.includes('NetworkError') || errorMessage.includes('network')) {
            logError('TrackingService', 'Network error in request_save_trackings. Connection may be offline:', errorMessage)
        } else {
            logError('TrackingService', 'Error en request_save_trackings:', error)
        }
        throw error
    }
}